import { render, staticRenderFns } from "./BaseInputField.vue?vue&type=template&id=6b323fd9&"
import script from "./BaseInputField.vue?vue&type=script&lang=ts&"
export * from "./BaseInputField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports